import { Spinner, useMedia } from '../../components/Boneyard';
import PropTypes from 'prop-types';
import { usePaypalState } from '../PaypalStateProvider';

const propTypes = {
  total: PropTypes.number,
  section: PropTypes.string,
};

const PaylaterMessage = ({ total, section }) => {
  const { isPaypalRendered } = usePaypalState();
  const mq = useMedia();
  const fontSize =
    section === 'cart'
      ? 12
      : section === 'payment'
      ? 16
      : mq.lte('sm')
      ? 12
      : 14;

  const contextualComponent = section === 'payment' ? 'PAY_LATER_MARK' : '';

  const logoType = section === 'payment' ? 'none' : 'primary';

  const paymentPageStyle = {
    width: mq.lte('md') ? 'auto' : '700px',
  };
  const bookingPathStyle = {
    minWidth: '100%',
  };

  return (
    <>
      {!isPaypalRendered ? (
        <Spinner size="xsmall" appearance="dark" inline />
      ) : (
        <div
          data-pp-message
          data-pp-layout="text"
          data-pp-text-color="black"
          data-pp-style-logo-type={logoType}
          data-pp-style-text-size={fontSize}
          data-pp-amount={total}
          style={section === 'payment' ? paymentPageStyle : bookingPathStyle}
          data-pp-contextualComponents={contextualComponent}
        ></div>
      )}
    </>
  );
};

PaylaterMessage.propTypes = propTypes;
export default PaylaterMessage;
